import { jsx } from 'react/jsx-runtime';

function TabSection({
  baseId,
  selectedTabId: selectedGroupId,
  children,
  ...props
}) {
  return /*#__PURE__*/jsx("section", {
    ...props,
    ref: props.ref,
    role: props.disabled ? undefined : "tabpanel",
    id: `${baseId}-panel-${selectedGroupId}`,
    "aria-labelledby": props.disabled ? undefined : `${baseId}-tab-${selectedGroupId}`,
    children: children
  });
}

export { TabSection };
//# sourceMappingURL=tab-section.js.map
